import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { setRunningIdeasAction } from "@oldDashboard/legacyActions/dashboardClient";

interface UseRunningIdeasProps {affiliateSelected: any, launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String, searching: boolean }
const useRunningIdeas = (props: UseRunningIdeasProps) => {
    const { affiliateSelected, launchSelected,timePeriodSelected, startDate, endDate, searching } = props;
    const [isLoading, setIsLoading] = useState(false);

    useEffect( () => {
        fetchRunningIdeas();
    }, [searching, launchSelected]);
    
    const fetchRunningIdeas = async() => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getRunningIdeas(affiliateSelected, launchSelected,timePeriodSelected, startDate, endDate);
            if(response)
                setRunningIdeasAction(response);
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }
     
    }
    return { isLoading, fetchRunningIdeas }
}

export default useRunningIdeas